/**
 * Polls for NetFile confirm entity comparison results and renders them safely
 * (DOM + textContent only, no innerHTML with server data).
 */
(function () {
  "use strict";

  var INTERVAL_MS = 5000;
  var MAX_WAIT_MS = 60000;
  var POLL_STARTED_ATTR = "data-confirm-comparison-polling";

  function renderResults(container, data) {
    container.innerHTML = "";
    container.style.display = "block";

    var alertDiv = document.createElement("div");
    alertDiv.className = "alert alert-success";
    var alertStrong = document.createElement("strong");
    alertStrong.textContent = "Confirm sync complete";
    alertDiv.appendChild(alertStrong);
    container.appendChild(alertDiv);

    var confirmCount =
      data.confirm_count != null ? String(data.confirm_count) : "—";
    var campaignCount =
      data.campaign_count != null ? String(data.campaign_count) : "—";
    var p1 = document.createElement("p");
    p1.appendChild(document.createTextNode("Confirm CSV entity count: "));
    var s1 = document.createElement("strong");
    s1.textContent = confirmCount;
    p1.appendChild(s1);
    p1.appendChild(document.createTextNode(". Campaign entity count: "));
    var s2 = document.createElement("strong");
    s2.textContent = campaignCount;
    p1.appendChild(s2);
    p1.appendChild(document.createTextNode("."));
    container.appendChild(p1);

    var onlyConfirmCount = data.only_in_confirm_count || 0;
    var onlyCampaignCount = data.only_in_campaign_count || 0;
    if (onlyConfirmCount > 0 || onlyCampaignCount > 0) {
      var p2 = document.createElement("p");
      p2.appendChild(document.createTextNode("Only in confirm CSV: "));
      var s3 = document.createElement("strong");
      s3.textContent = String(onlyConfirmCount);
      p2.appendChild(s3);
      p2.appendChild(document.createTextNode(". Only in campaign: "));
      var s4 = document.createElement("strong");
      s4.textContent = String(onlyCampaignCount);
      p2.appendChild(s4);
      p2.appendChild(document.createTextNode("."));
      container.appendChild(p2);

      if (data.only_in_confirm && data.only_in_confirm.length > 0) {
        var p3 = document.createElement("p");
        var small3 = document.createElement("small");
        small3.textContent =
          "NetFile IDs only in confirm: " + data.only_in_confirm.join(", ");
        p3.appendChild(small3);
        container.appendChild(p3);
      }
      if (data.only_in_campaign && data.only_in_campaign.length > 0) {
        var p4 = document.createElement("p");
        var small4 = document.createElement("small");
        small4.textContent =
          "NetFile IDs only in campaign: " + data.only_in_campaign.join(", ");
        p4.appendChild(small4);
        container.appendChild(p4);
      }
    } else {
      var pElse = document.createElement("p");
      pElse.textContent = "Entity IDs match between confirm CSV and campaign.";
      container.appendChild(pElse);
    }
  }

  function startPolling(panel) {
    if (panel.getAttribute(POLL_STARTED_ATTR) === "true") {
      return;
    }
    panel.setAttribute(POLL_STARTED_ATTR, "true");

    var pollUrl = panel.getAttribute("data-poll-url");
    var operationId = panel.getAttribute("data-operation-id");
    var statusEl = panel.querySelector("#confirm-comparison-status");
    var resultsEl = panel.querySelector("#confirm-comparison-results");
    var timeoutEl = panel.querySelector("#confirm-comparison-timeout");

    if (!pollUrl || !operationId || !statusEl || !resultsEl || !timeoutEl) {
      return;
    }

    var attempts = 0;
    var maxAttempts = MAX_WAIT_MS / INTERVAL_MS;

    function showResults(data) {
      statusEl.style.display = "none";
      timeoutEl.style.display = "none";
      renderResults(resultsEl, data);
    }

    function showTimeout() {
      statusEl.style.display = "none";
      resultsEl.style.display = "none";
      timeoutEl.style.display = "block";
    }

    function poll() {
      attempts += 1;
      var sep = pollUrl.indexOf("?") >= 0 ? "&" : "?";
      var url =
        pollUrl + sep + "operation_id=" + encodeURIComponent(operationId);
      fetch(url, { headers: { Accept: "application/json" } })
        .then(function (r) {
          return r.json();
        })
        .then(function (json) {
          if (json.ready && json.confirm_count != null) {
            showResults(json);
            return;
          }
          if (attempts >= maxAttempts) {
            showTimeout();
            return;
          }
          setTimeout(poll, INTERVAL_MS);
        })
        .catch(function () {
          if (attempts >= maxAttempts) {
            showTimeout();
          } else {
            setTimeout(poll, INTERVAL_MS);
          }
        });
    }

    poll();
  }

  function init() {
    var panel = document.getElementById("confirm-entity-comparison");
    if (panel) {
      startPolling(panel);
      return;
    }
    // Defer once: Turbo may fire turbo:load before the new body is fully in the DOM.
    requestAnimationFrame(function () {
      panel = document.getElementById("confirm-entity-comparison");
      if (panel) {
        startPolling(panel);
      } else {
        watchForPanel();
      }
    });
  }

  function watchForPanel() {
    if (document.getElementById("confirm-entity-comparison")) {
      return;
    }
    var observer = new MutationObserver(function () {
      var panel = document.getElementById("confirm-entity-comparison");
      if (panel) {
        observer.disconnect();
        startPolling(panel);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    // Also run a one-off check after a short delay in case the panel was added synchronously.
    setTimeout(function () {
      var panel = document.getElementById("confirm-entity-comparison");
      if (panel) {
        observer.disconnect();
        startPolling(panel);
      }
    }, 100);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  document.addEventListener("turbo:load", init);
})();
